import "./login.scss";
import base64 from "base-64";
import { SHA256 } from "crypto-js";
import React from "react";
import { useState, FormEvent, useContext, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import TextInput from "../../../shared/components/text-input/text-input";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { authenticate, heartbeat, failedToast } from "../../../shared/utils/api";

const Login = () => {
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  
  const { sendRequest: authenticateRequest, data: loadedData, status: allStatusAuthenticate, error: loginError } = useHttp(authenticate, false, "" );
  const { sendRequest: heartbeatRequest, status: statusHeartbeat, error: heartbeatError } = useHttp(heartbeat, false, "" );

  useEffect(() => {
    authCtx.token && navigate("/");
  }, [authCtx.token, navigate]);

  useEffect(() => {
    heartbeatRequest("");
  }, []);

  useEffect(() => {
    if (statusHeartbeat === "completed" && heartbeatError) {
      failedToast("Cannot connect to the backend", "true");
    }
  }, [statusHeartbeat]);

  useEffect(() => {
    if (allStatusAuthenticate === "completed" && !loginError && loadedData.success) {
      const expirationTime = new Date(new Date().getTime() + (28800000));
      authCtx.login(loadedData.token, expirationTime.toISOString(), false, loadedData.user_id);
    }
  }, [allStatusAuthenticate, authCtx, loginError, loadedData]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === true) {
      const hashedPassword = SHA256(data.password).toString();
      const auth = "Basic " + base64.encode(data.email + ":" + hashedPassword);
      authenticateRequest("login", auth);
    }
    setValidated(true);
  };

  return (
    <div role="loginBack" className="Login">
      <Form validated={validated} noValidate onSubmit={handleSubmit} className="Login-container">
        <div className="Login-logo">
          <img src="/images/LogoBlackPng.png" className="d-inline-block align-top" alt="Sygno"/>
        </div>
        <div className="Login-content">
          <div className="form-group mt-3">
            <TextInput
              type="email"
              handleOnChange={(targetVal) => setData({...data, email: targetVal})}
              id="email"
              label="Email address"
              required={true}
              controlled={true}
              value={data.email}
              noRoleCheck={true}
              inputKey="email"
            />
            <div className="form-group mt-3">
              <TextInput
                type="password"
                handleOnChange={(targetVal) => setData({...data, password: targetVal})}
                id="password"
                label="Password"
                required={true}
                inputKey="password"
                controlled={true}
                noRoleCheck={true}
                value={data.password}
              />
            </div>

          </div>

          <Button type="submit" className="Login-submit btn btn-primary">
            Login
          </Button>

          <div className="Login-error">{loginError}</div>
        </div>
      </Form>
    </div>
  );
};

export default Login;
